module.exports = __webpack_public_path__ + "static/media/huawei.e8da5e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/huawei.png
// module id = 55
// module chunks = 0